import { FC } from 'react'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { floatFormat } from '../../utils/formFormat'
import { maxLengthRule, requiredRule } from '../../utils/formRules'
import { TControls } from '../../../features/userInfoForm/types'

type TProps = {
  label?: string
} & TControls
const IncomeAnnual: FC<TProps> = ({ control, label }) => (
  <div>
    <CustomLabel label={label || 'Income(annual) *'}/>
    <CustomInput
      name="incomeAnnual"
      control={control}
      handleChange={floatFormat}
      rules={{
        required: requiredRule(),
        maxLength: maxLengthRule(100)
      }}
    />
  </div>
)
export default IncomeAnnual
